// extracted by mini-css-extract-plugin
module.exports = {"container":"zy-z","heading":"Ay-z","links":"By-z","linkBtn":"Cy-z","disabled":"Dy-z","linkUppercaseBold":"Ey-z","copy":"Fy-z","subCopy":"Gy-z"};